import React from "react";
import { Link } from "react-router-dom";
import "./PageStyles.css";
import { steps as defaultSteps } from "../../data/content.js";
import * as proof from "../../data/proof.js";
import useReveal from "../../hooks/useReveal.js";

export const Reveal = ({ children, className = "" }) => {
  const ref = useReveal();
  return <div ref={ref} className={`rv ${className}`}>{children}</div>;
};

export const Hero = ({ title, text, image, cta, eyebrow }) => (
  <>
    <header className="pg-hero">
      {eyebrow && <div className="pg-eyebrow">{eyebrow}</div>}
      <h1>{title}</h1>
      <div className="pg-hero-side">
        {text && <p>{text}</p>}
        {cta && <Link className="pg-btn" to="/book">{cta}</Link>}
      </div>
    </header>
    {image && <img className="pg-hero-img" src={image} alt="" />}
  </>
);

export const Section = ({ title, n, children, alt }) => (
  <section className={`pg-section${alt ? " alt" : ""}`}>
    <Reveal className={title ? "pg-split" : ""}>
      {title && (
        <h2>
          {n && <small>{n}</small>}
          {title}
        </h2>
      )}
      <div className="pg-body">{children}</div>
    </Reveal>
  </section>
);

// Ruled editorial rows (replaces equal-width cards)
export const Cards = ({ items }) => (
  <div className="pg-rows">
    {items.map(([t, d]) => (
      <div key={t} className="pg-row">
        <h3>{t}</h3>
        <p>{d}</p>
      </div>
    ))}
  </div>
);

export const CTA = ({ text = "Ready to take climate action?", label = "Book a discovery call" }) => (
  <div className="pg-cta">
    <h2>{text}</h2>
    <Link className="pg-btn light" to="/book">{label}</Link>
  </div>
);

export const Steps = ({ items = defaultSteps }) => (
  <ol className="pg-steps">
    {items.map(([t, d], i) => (
      <li key={t}>
        <span className="pg-step-n">{String(i + 1).padStart(2, "0")}</span>
        <h3>{t}</h3>
        <p>{d}</p>
      </li>
    ))}
  </ol>
);

export const FAQ = ({ items }) => (
  <div className="pg-faq">
    {items.map(([q, a]) => (
      <details key={q}><summary>{q}</summary><p>{a}</p></details>
    ))}
  </div>
);

// Renders only the proof you've filled in (src/data/proof.js).
export const ProofBand = () => {
  const { stats, logos, testimonials } = proof;
  if (!stats.length && !logos.length && !testimonials.length) return null;
  return (
    <section className="pg-section alt">
      <Reveal>
        {stats.length > 0 && (
          <div className="pg-stats">
            {stats.map((s) => (
              <div key={s.label}><b>{s.value}</b><span>{s.label}</span></div>
            ))}
          </div>
        )}
        {logos.length > 0 && (
          <div className="pg-logos">
            {logos.map((l) => (
              <a key={l.name} href={l.href || undefined} target="_blank" rel="noreferrer">
                <img src={l.src} alt={l.name} />
              </a>
            ))}
          </div>
        )}
        {testimonials.map((t) => (
          <blockquote className="pg-quote" key={t.name}>“{t.quote}”<footer>{t.name}, {t.role}, {t.org}</footer></blockquote>
        ))}
      </Reveal>
    </section>
  );
};
